import type {
  DocumentationFileIds,
  DocumentationSlots,
  DraftMetadataFileEntry
} from '../../../../../utils/conversationalMode/projectAutofillDraftUtils.ts'
import {
  formatSlotOriginSummary,
  type DocumentationSlotKey
} from '../../../../../utils/conversationalMode/documentationSlotSummaryUtils.ts'

export type SlotOriginActionMeta = {
  meta: string | null
  pdfHref: string | null
  hasOrigin: boolean
}

export function buildSlotOriginActionMeta(input: {
  slot: DocumentationSlotKey
  slots: DocumentationSlots
  fileIds: DocumentationFileIds
  draftFiles: DraftMetadataFileEntry[]
  maxPage?: number | null
  pdfBaseUrl?: string
}): SlotOriginActionMeta {
  const summary = formatSlotOriginSummary(input)
  if (!summary.hasOrigin) {
    return { meta: null, pdfHref: null, hasOrigin: false }
  }
  return {
    meta: `Del documento: ${summary.text}`,
    pdfHref: summary.pdfHref ?? null,
    hasOrigin: true
  }
}
